import { render, staticRenderFns } from "./zgody.vue?vue&type=template&id=f1414db0&"
import script from "./zgody.vue?vue&type=script&lang=js&"
export * from "./zgody.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports